import {DatasetModel} from "../datasetModel";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {toDate} from "../../../index";
import React, {useEffect, useState} from "react";
import {useMediaQuery} from "react-responsive";
import {mobileMaxWidthQuery} from "../../../core/layout/responsive";
import useLogbogApi from "../../../core/hooks/useLogbogApi";

interface DatasetCardSubheaderComponentProps {
    dataset: DatasetModel;
}

export function DatasetCardSubheaderComponent(props: DatasetCardSubheaderComponentProps) {
    const IsMobile = useMediaQuery(mobileMaxWidthQuery);
    const { evalueringstatistikApi } = useLogbogApi();
    const [specialeNames, setSpecialeNames] = useState<string[]>();

    const CreateXOfYString = (x?: number, y?: number, ofString= Localizer.global_af()) => {
        return `${x ?? 0} ${y ? ofString : ""} ${y ?? ""} `;
    }

    const OutOfMaxEvalueringerDisplayString = () => {

        const dataset = props.dataset;
        const antalEvalueringerIAlt = dataset.maxAmountEvalueringer === undefined ? 0 : dataset.maxAmountEvalueringer; //Denne er null, hvis der er under 3
        const antalForloebEvalueret = dataset.antalForloebEvalueretTotal ?? 0;
        const antalEvalueringerMedAdgang = dataset.uddannelsesstederEvalueringstatistik.map(e => e.antalEvalueringerMedAdgangTil).sum();

        if(antalForloebEvalueret === 0) {
            return !antalEvalueringerIAlt && antalEvalueringerMedAdgang === 0
                ? Localizer.evalueringPage_ingenEvalueringer()
                : Localizer.evalueringPage_underTreEvalueringer()
        }

        if (antalEvalueringerIAlt === 3 && antalForloebEvalueret < 3) {
            return Localizer.evalueringPage_underTreEvalueringer() + Localizer.evalueringPage_udAf() + antalEvalueringerIAlt + Localizer.evalueringPage_mulige()
        }

        const isEmpty = antalForloebEvalueret === 0;
        return isEmpty ? Localizer.evalueringPage_ingenEvalueringer() : CreateXOfYString(antalForloebEvalueret, antalEvalueringerIAlt === undefined ? 0 : antalEvalueringerIAlt);
    }

    useEffect(() => {
        const DetermineSpecialeDisplayString = async () => {
            const data = await evalueringstatistikApi.getSpecialerSelect();
            const filteredSpecialer = data.filter(x => !props.dataset.specialeIds || props.dataset.specialeIds?.length === 0 || props.dataset.specialeIds.includes(x.id)).map(x => x.text);
            setSpecialeNames(filteredSpecialer);
        }
        DetermineSpecialeDisplayString()
    }, [evalueringstatistikApi, props.dataset.specialeIds])

    const DetermineUddannelsestypeDisplayString = () : string => {
        return (props.dataset.stillingsTypeName && props.dataset.stillingsTypeName.length === 0)
            ? Localizer.global_all()
            : props.dataset.stillingsTypeName?.join(", ") || Localizer.global_all();
    }

    const BreakPoint = () : JSX.Element => {
        if(IsMobile) {
            return <>&nbsp;</>;
        }

        return (
        <>
            &nbsp;
            <div> ⋅ </div>
            &nbsp;
        </>)
    }

    const SubheaderText = (title: string, text: string, addBreakPoint=true) : JSX.Element => {
        return (
        <>
            { addBreakPoint &&
                BreakPoint()
            }
            <div className="flex-container small wrap">
                <div>{title}: </div>
                &nbsp;
                <div>{text}</div>
            </div>
        </>)
    }

    return (
        <>
            <div className="flex-container align-items-center wrap">
                {props.dataset.fromDate && props.dataset.toDate && <>
                    {SubheaderText(Localizer.global_periode(), `${toDate(props.dataset.fromDate).dateWithoutTimeFormat(true)} - ${toDate(props.dataset.toDate).dateWithoutTimeFormat(true)}`, false)}
                </>}
                {SubheaderText(Localizer.uddannelsesType(), DetermineUddannelsestypeDisplayString())}
                {SubheaderText(Localizer.global_speciale(), props.dataset.specialeIds && props.dataset.specialeIds?.length > 0 && specialeNames ? specialeNames?.map(x => x).join(", ") : Localizer.global_all())}
                {SubheaderText(Localizer.evalueringPage_evalueringer(), OutOfMaxEvalueringerDisplayString())}

                {props.dataset.uddannelsesstederEvalueringstatistik.every(x => x.antalForloeb === 0) &&
                    <>
                        {BreakPoint()}
                        <div className="flex-container small">
                            <div className="subtle alert-warning">{Localizer.createEvalueringsstatistikPage_ingenForloebMedEvalueringer()}</div>
                        </div>
                    </>
                }
            </div>
        </>
    )
}
